export const PDP_PASSWORD_RESET_ORIGIN = 'pdp password reset';

export const contactDealerModalTypes = {
    MAKE_OFFER: 'MAKE_OFFER',
    CONFIRMATION: 'CONFIRMATION',
    CONFIRMATION_NO_SECONDARY_MESSAGE: 'CONFIRMATION_NO_SECONDARY_MESSAGE',
    CONTACT_DEALER: 'CONTACT_DEALER',
    CONTACT_DEALER_NO_OFFER: 'CONTACT_DEALER_NO_OFFER',
    REQUEST_CUSTOMIZATION: 'REQUEST_CUSTOMIZATION',
    REQUEST_IMAGES: 'REQUEST_IMAGES',
    REQUEST_PRICE: 'REQUEST_PRICE',
    ERROR: 'ERROR',
    LOADING: 'LOADING',
    SHIPPING_QUOTE_REQUEST: 'SHIPPING_QUOTE_REQUEST',
    DESIGN_YOUR_OWN: 'DESIGN_YOUR_OWN',
    DISPLAY_CONTACT_SELLER_MESSAGE: 'DISPLAY_CONTACT_SELLER_MESSAGE',
};

export const SHOW_CONTACT_DEALER_PARAM = 'showContactDealer';
export const CONTACT_SELLER_CLICK = 'contact_seller_click';
export const VARIANT = 'VARIANT';
